import { EnumOptInMethodTypes } from 'entities/Compliance/api/types/complianceType'

export enum LocalNumbersRoutes {
  // from business profile steps. Show only in rejected Brand status
  generalInfo = 'general-info',
  businessInfo = 'business-info',
  peopleToContact = 'people-to-contact',

  root = 'local-numbers',
  campaignUseCases = 'campaign-use-cases',
  messages = 'messages',
  optInMethod = 'opt-in-method',
  optInOnlineFormContent = 'opt-in-online-form-consent',
  optInPaperFormContent = 'opt-in-paper-form-consent',
  optInViaTextContent = 'opt-in-via-text-consent',
  optInQrCodeContent = 'opt-in-qr-code-consent',
  forbiddenMessageTopics = 'forbidden-message-topics',
  package = 'package',
  orderSummary = 'order-summary',
  tollFreeNumbers = 'toll-free-numbers',
}

export const IOptInMethodsMap: Partial<Record<LocalNumbersRoutes, EnumOptInMethodTypes>> = {
  [LocalNumbersRoutes.optInOnlineFormContent]: EnumOptInMethodTypes.onlineForm,
  [LocalNumbersRoutes.optInPaperFormContent]: EnumOptInMethodTypes.paperForm,
  [LocalNumbersRoutes.optInViaTextContent]: EnumOptInMethodTypes.text,
  [LocalNumbersRoutes.optInQrCodeContent]: EnumOptInMethodTypes.qrCode,
}

export const IOptInYTypeMap: Partial<Record<EnumOptInMethodTypes, LocalNumbersRoutes>> = {
  [EnumOptInMethodTypes.onlineForm]: LocalNumbersRoutes.optInOnlineFormContent,
  [EnumOptInMethodTypes.paperForm]: LocalNumbersRoutes.optInPaperFormContent,
  [EnumOptInMethodTypes.text]: LocalNumbersRoutes.optInViaTextContent,
  [EnumOptInMethodTypes.qrCode]: LocalNumbersRoutes.optInQrCodeContent,
}
